<template>
  <div class="mod-config">
    <el-form :inline="true"
             :model="dataForm"
             @keyup.enter.native="getDataList()">
      <el-form-item>
        总金额：{{allmoney}}
      </el-form-item>
    </el-form>
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection"
                       header-align="center"
                       align="center"
                       width="50">
      </el-table-column>
      <el-table-column prop="id"
                       header-align="center"
                       align="center"
                       label="流水id">
      </el-table-column>
      <el-table-column prop="ordernum"
                       header-align="center"
                       align="center"
                       label="订单号">
      </el-table-column>
      <el-table-column prop="name"
                       header-align="center"
                       align="center"
                       label="名称">
      </el-table-column>
      <el-table-column prop="phone"
                       header-align="center"
                       align="center"
                       label="电话">
      </el-table-column>
      <el-table-column prop="money"
                       header-align="center"
                       align="center"
                       label="金额">
      </el-table-column>
      <el-table-column prop="status"
                       header-align="center"
                       align="center"
                       label="状态">
                       <template slot-scope="scope2">
          <el-tag v-if="scope2.row.status===0"
                  type="error">未支付</el-tag>
          <el-tag v-if="scope2.row.status===1"
                  type="success">已经支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createtime"
                       header-align="center"
                       align="center"
                       label="创建时间">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import AddOrUpdate from '@/components/jgliushui-add-or-update'
export default {
  data () {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      allmoney: 0
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgliushui/getalllist',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'phone': this.dataForm.key
        }
      }).then((data) => {
        data = data.data
          var allmoneys = 0
          for (var i = 0; i < data.length; i++) {
            if(data[i].status==1){
              data[i].money = parseFloat(data[i].money) / 100
              allmoneys = allmoneys + data[i].money
            }else{
              data[i].money = parseFloat(data[i].money) / 100
            }
          }
          this.dataList = data
          this.allmoney = allmoneys
        
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/jxjg/jgliushui/delete',
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/jgliushui.vue